<template>
  <van-row  >
    <div class="item-content" >
      <van-col :span='6' >
        <div class="lensImg">
          <img  :src="lensImgUrl" />
        </div>
      </van-col>
      <van-col :span='18' >
          <template slot="default">
            <div classs="clearfix">
              <div class="comparsion-li-title fl">
                <div class="lens-item-name" :class = "{oldLens: lensData.isOldLens}">{{lensData.name}}</div>
                <div class="lens-item-name" :class = "{oldLens: lensData.isOldLens}">{{lensData.vcode}}</div>
              </div>
              <div class="lens-value fr">
                <div class="lens-item-title">{{$t('T_LENS_THROW_DISTANCE')}}</div>
                <div class="comparsion-distance">{{lensData.distance}}</div>
              </div>
            </div>
            <div class="lens-item-range">{{$t(throwRangeLang)}}</div>
            <div  class="van-progress" ref="progress" stroke-width="2">
              <span class="van-progress__portion" style="background: rgb(16, 33, 139);" :style="{width:distanceWidth+'px',left:distanceLeftWidth+'px'}"></span>
            </div>
            <!-- <van-progress :percentage="50" pivot-text="" stroke-width="2" color="#10218b"/> -->
            <div class="clearfix comparsion-li-title-num">
              <span class="comparsion-li-title-left">{{throwRangeMin}}</span>
              <span class="comparsion-li-title-right">{{throwRangeMax}}</span>
            </div>
          </template>
      </van-col>
    </div>
  </van-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'lensItem',
  data () {
    return {
      throwRangeMin: 0,
      distanceLeftWidth: '',
      distanceWidth: '',
      name: ''
    }
  },

  props: ['lensData'],
  computed: {
    lensImgUrl () {
      console.log(process.env.BASE_URL)
      let data = this.lensData.url.replace('static/', "./")
      return data + '.jpg'
    },
    ...mapState([
      'graph'
    ]),
    ...mapGetters([
      'unitLabel'
    ]),
    throwRangeMax () {
      let val
      switch (this.graph.unit) {
        case 'T_METRE_M':
          val = 300
          break
        case 'T_MILLIMETER_MM':
          val = 300000
          break
        case 'T_FEET_DECIMAL':
          val = 900
          break
        case 'T_INCH_DECIMAL':
          val = 12000
          break
      }
      return val
    },
    throwRangeLang () {
      let val
      switch (this.graph.unit) {
        case 'T_METRE_M':
          val = 'T_LENS_THROW_RANGE_M'
          break
        case 'T_MILLIMETER_MM':
          val = 'T_LENS_THROW_RANGE_MM'
          break
        case 'T_FEET_DECIMAL':
          val = 'T_LENS_THROW_RANGE_FEET'
          break
        case 'T_INCH_DECIMAL':
          val = 'T_LENS_THROW_RANGE_INCH'
          break
      }
      return val
    }
  },
  mounted () {
    let progressWidth = this.$refs.progress.offsetWidth
    this.distanceWidth = this.lensData.distanceMax / (this.throwRangeMax / progressWidth)
    this.distanceLeftWidth = this.lensData.distanceMin / (this.throwRangeMax / progressWidth)
  },
  components: {
  }
}
</script>

<style scoped>
  .van-cell {
    padding: 0;
    display: table;
  }

  .van-cell__right-icon {
    display: table-cell;
    vertical-align: middle;
    text-align: right;
  }
  .item-content{
    height: 70px;
    border-bottom:0.5px solid #e3e3e3;
    padding-bottom:8px;
    padding-right: 10px
  }
  .lensImg{
    border:1px solid #ccc;
    width: 60px;
    height: 60px;
    line-height: 60px;
    vertical-align: middle
  }
  img{
    width: 54px;
    height: 54px;
    object-fit: contain;
    padding-top:3px
  }
  .van-progress{
    border-radius: 0;
    height: 2px;
  }
  .item-content .van-col--6{
    width: 71px
  }
  .item-content .van-col--18{
    width:calc(100% - 71px)
  }
</style>
